import React, { useState } from "react"

import NonOrganizationStudents from "./NonOrganizationStudents"
import Organizations from "./Organizations"
import StudentInfoModal, {
  UncontactedStudentsContext,
} from "./StudentInfoModal"

const UncontactedStudents = () => {
  const [student, setStudent] = useState()

  return (
    <UncontactedStudentsContext.Provider value={[student, setStudent]}>
      <StudentInfoModal />
      <NonOrganizationStudents />
      <Organizations />
    </UncontactedStudentsContext.Provider>
  )
}

export default UncontactedStudents
export { UncontactedStudentsContext }
